var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-container',{staticClass:"m-0 p-0 h-100",attrs:{"id":"app","fluid":""}},[_c('h1',[_vm._v("Maintenance")]),_c('p',[_vm._v("We've got an unexpected error. We'll be back very soon.")])])
}
var staticRenderFns = []

export { render, staticRenderFns }